// ============================================================================
// Audio Types for Cloudflare Realtime SFU Integration
// ============================================================================
// AudioTrackInfo is defined in liveState.ts to avoid circular dependencies
// ============================================================================
// Audio Error Codes
// ============================================================================
export var AudioErrorCode;
(function (AudioErrorCode) {
    // Permission errors
    AudioErrorCode["MICROPHONE_PERMISSION_DENIED"] = "MICROPHONE_PERMISSION_DENIED";
    AudioErrorCode["NOT_ON_STAGE"] = "NOT_ON_STAGE";
    // Session errors
    AudioErrorCode["SESSION_CREATE_FAILED"] = "SESSION_CREATE_FAILED";
    AudioErrorCode["SESSION_NOT_FOUND"] = "SESSION_NOT_FOUND";
    // Track errors
    AudioErrorCode["TRACK_PUBLISH_FAILED"] = "TRACK_PUBLISH_FAILED";
    AudioErrorCode["TRACK_SUBSCRIBE_FAILED"] = "TRACK_SUBSCRIBE_FAILED";
    AudioErrorCode["TRACK_NOT_FOUND"] = "TRACK_NOT_FOUND";
    // Connection errors
    AudioErrorCode["SFU_UNAVAILABLE"] = "SFU_UNAVAILABLE";
    AudioErrorCode["RENEGOTIATION_FAILED"] = "RENEGOTIATION_FAILED";
    // Generic
    AudioErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(AudioErrorCode || (AudioErrorCode = {}));
// ============================================================================
// Type Guards
// ============================================================================
export function isAudioPublishTrackMessage(msg) {
    return (typeof msg === 'object' &&
        msg !== null &&
        'type' in msg &&
        msg.type === 'audio_publish_track' &&
        'trackId' in msg &&
        typeof msg.trackId === 'string');
}
export function isAudioClientMessage(msg) {
    return isAudioPublishTrackMessage(msg);
}
